<template>
  <div style="display:inline-block; margin-left:20px;">
    <el-button type="text" @click="dialogVisible=true">编辑</el-button>
    <el-dialog
      center
      top="5vh"
      title="门店地址编辑"
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="editAddress"
        style="margin-top:-30px 0;"
        :model="data"
        label-width="150px"
        :rules="rules"
        size="mini"
      >
        <el-form-item label="门店地址" prop="address">
          <cascader-address
            :provinceId.sync="data.provinceId"
            :provinceName.sync="data.provinceName"
            :cityId.sync="data.cityId"
            :cityName.sync="data.cityName"
            :areaId.sync="data.regionId"
            :areaName.sync="data.regionName"
            :value="value"
            :text.sync="text"
            style="display: inline;"
          />
          <br />
          <el-input
            style="margin-top: 20px;width: 300px;"
            v-model="data.address"
            placeholder="请输入门店地址信息"
          ></el-input>
          <el-button class="marLeft10" @click="()=>{ $refs.map.search() }">定位</el-button>
        </el-form-item>
        <map-address
          v-if="dialogVisible"
          ref="map"
          style="margin-bottom: 20px; margin-top: 20px;"
          :keyword="`${text.join('')}${data.address}`"
          @point="getPoint"
        />
        <el-form-item label="定位地址" prop="addressDetail">
          <el-input
            :disabled="true"
            style="width: 300px;"
            v-model="data.addressDetail"
            placeholder="请输入门店详细地址，精确到门牌号"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">保存并提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["value", "textAddress", "textAddressDetail", "storeId"],
  name: "edit-address",
  data() {
    var checkAddressDetail = (rules, val, callback) => {
      const { provinceId, cityId, regionId, address } = this.data;
      if (provinceId && cityId && regionId && address) {
        callback();
      }
      callback(new Error(rules.message));
    };
    return {
      data: {
        provinceId: "",
        cityId: "",
        regionId: "",
        provinceName: "",
        cityName: "",
        regionName: "",
        lat: "",
        lng: "",
        address: "",
        addressDetail: ""
      },
      text: [],
      dialogVisible: false,
      rules: {
        addressDetail: [
          {
            required: true,
            message: "请填写详细地址"
          }
        ],
        address: [
          {
            validator: checkAddressDetail,
            required: true,
            message: "请填写门店地址信息"
          }
        ]
      }
    };
  },
  watch: {
    textAddress: {
      immediate: true,
      handler: function(val) {
        this.data.address = val;
      }
    },
    textAddressDetail: {
      immediate: true,
      handler: function(val) {
        this.data.addressDetail = val;
      }
    }
  },
  methods: {
    handleClose() {
      this.$refs["editAddress"].resetFields();
      Object.assign(this.data, {
        lat: "",
        lng: ""
      });
      this.dialogVisible = false;
    },
    getPoint(info) {
      this.data.address = info.title;
      this.data.lng = info.point.lng;
      this.data.lat = info.point.lat;
      this.data.addressDetail = info.address;
    },
    submit() {
      this.$refs["editAddress"].validate(async val => {
        if (!val) return;
        const { ret, data } = await _api.store.updateAddress({
          storeId: this.storeId,
          ...this.data
        });
        if (ret && data) {
          this.$message({
            type: "success",
            message: "编辑门店地址成功"
          });
          Object.assign(this.data, {
            lat: "",
            lng: ""
          });
          this.$emit("success");
          this.dialogVisible = false;
        }
      });
    }
  }
};
</script>

<style scoped>
</style>